module.exports = __webpack_public_path__ + "img/product2_11B984_quota.d208b700.png";